var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-level"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('sidebar.level'))+":")]),_c('div',{staticClass:"value",style:({
            'background-color': _vm.getLevelColor(_vm.getPlayerLevel),
            'color': _vm.getPlayerLevel === 'Bronze' ? '#fff' : '#000'
        })},[_vm._v(_vm._s(_vm.getPlayerLevel))])])}
var staticRenderFns = []

export { render, staticRenderFns }